
import { useTranslation } from 'react-i18next';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import Card from '../../../components/base/Card';

export default function EventsSection() {
  const { t } = useTranslation();
  const { ref, isVisible } = useScrollAnimation();

  // Obtener los eventos directamente del objeto de traducción
  const events = t('events.items', { returnObjects: true }) as any[];

  return (
    <section 
      id="events" 
      ref={ref}
      className={`py-12 sm:py-16 md:py-24 relative transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
      style={{
        backgroundImage: 'url(https://public.readdy.ai/ai/img_res/49f84a0a8c40c6169181bc5aaa9cb0f0.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Overlay para mejorar legibilidad */}
      <div className="absolute inset-0 bg-white/85"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-neutral-900 tracking-tight mb-3 sm:mb-4 sm:mb-6 px-2">
            {t('events.title')}
          </h2>
          <p className="text-sm sm:text-base lg:text-lg text-neutral-600 max-w-3xl mx-auto leading-relaxed px-4">
            {t('events.subtitle')}
          </p>
        </div>
        
        {Array.isArray(events) && events.length > 0 ? (
          <div className="grid gap-4 sm:gap-6 lg:gap-8 sm:grid-cols-2 lg:grid-cols-3 px-2 sm:px-0">
            {events.map((event: any, index: number) => (
              <Card key={index} hover className="h-full bg-white/95 backdrop-blur-sm">
                <div className="text-center h-full flex flex-col p-4 sm:p-6">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-16 md:h-16 bg-neutral-900 text-white rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                    <i className="ri-calendar-line text-base sm:text-lg md:text-2xl"></i>
                  </div>
                  <div className="text-xs sm:text-sm font-medium text-neutral-900 bg-neutral-100 rounded-full px-2 sm:px-3 py-1 inline-block mx-auto mb-2 sm:mb-3">
                    {event.date}
                  </div>
                  <h3 className="text-base sm:text-lg md:text-xl font-semibold text-neutral-900 mb-2 sm:mb-3 leading-tight px-1">
                    {event.title}
                  </h3>
                  <p className="text-xs sm:text-sm md:text-base text-neutral-600 mb-3 sm:mb-4 flex-grow leading-relaxed px-1">
                    {event.description}
                  </p>
                  <div className="flex items-center justify-center text-xs sm:text-sm text-neutral-500 mt-auto">
                    <div className="w-3 h-3 sm:w-4 sm:h-4 flex items-center justify-center mr-1 sm:mr-2">
                      <i className="ri-map-pin-line"></i>
                    </div>
                    <span className="text-center text-xs sm:text-sm leading-tight">{event.address}</span>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        ) : (
          <div className="text-center py-8 sm:py-12 px-4">
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-white/90 backdrop-blur-sm text-neutral-400 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6 shadow-lg">
              <i className="ri-calendar-line text-lg sm:text-2xl"></i>
            </div>
            <div className="bg-white/90 backdrop-blur-sm rounded-lg p-4 sm:p-6 max-w-2xl mx-auto shadow-lg">
              <p className="text-base sm:text-lg text-neutral-500 leading-relaxed">
                {t('events.noEvents')}
              </p>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
